export const enum EChartsViewMode {
  OVERLAY,
  CASCADE
}
